var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.hasAssessments
        ? _c(
            "tippy",
            {
              attrs: {
                arrow: "",
                theme: `${_vm.$theme.name}`,
                placement: "top",
              },
            },
            [
              _c("div", { staticClass: "card narrow-line" }, [
                _c("div", { staticClass: "card-header p-1" }, [
                  _c("span", [_vm._v("Assessment History")]),
                ]),
                _c("div", { staticClass: "card-body p-1" }, [
                  _c("table", { staticClass: "table is-narrow is-fullwidth" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th"),
                        _c(
                          "th",
                          {
                            staticClass: "has-vertical-middle",
                            attrs: { colspan: _vm.numValuesInColumn },
                          },
                          [
                            _c("span", { staticClass: "badge badge-sm" }, [
                              _vm._v("Quoted"),
                            ]),
                          ]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "has-vertical-middle",
                            attrs: { colspan: _vm.numValuesInColumn },
                          },
                          [
                            _c("span", { staticClass: "badge badge-sm" }, [
                              _vm._v("Authorised"),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.itemAssessments, function (assessment) {
                        return _c(
                          "tr",
                          { key: _vm.getSupplementaryNo(assessment) },
                          [
                            _c(
                              "td",
                              { staticClass: "label-xxs has-vertical-middle" },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getSupplementaryNo(assessment) ===
                                          0,
                                        expression:
                                          "getSupplementaryNo(assessment) === 0",
                                      },
                                    ],
                                  },
                                  [_vm._v("Original")]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getSupplementaryNo(assessment) >
                                          0,
                                        expression:
                                          "getSupplementaryNo(assessment) > 0",
                                      },
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      "Supp #" +
                                        _vm._s(
                                          _vm.getSupplementaryNo(assessment)
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "has-vertical-middle",
                                class: _vm.hasTagValue(assessment[0])
                                  ? "has-text-centered"
                                  : "",
                                attrs: {
                                  colspan: _vm.hasTagValue(assessment[0])
                                    ? _vm.numValuesInColumn
                                    : 1,
                                },
                              },
                              [
                                assessment[0]
                                  ? _c("div", [
                                      assessment[0].isQuoteItemDeleted
                                        ? _c("div", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-sm tag is-danger",
                                              },
                                              [_vm._v(" Deleted ")]
                                            ),
                                          ])
                                        : assessment[0].reportOnly
                                        ? _c("div", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-sm tag is-info",
                                              },
                                              [_vm._v(" Report Only ")]
                                            ),
                                          ])
                                        : _c("div", [
                                            _c("div", [
                                              _vm.numValuesInColumn > 1
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "badge badge-sm",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$filters.formatNumber(
                                                            assessment[0]
                                                              .hourValue
                                                          )
                                                        ) + "h "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "badge badge-sm",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$filters.formatCurrency(
                                                              _vm.totalValue(
                                                                assessment[0]
                                                              ),
                                                              _vm.$userInfo
                                                                .locale
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                            ]),
                                          ]),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                            _vm.numValuesInColumn > 1 &&
                            !_vm.hasTagValue(assessment[0])
                              ? _c(
                                  "td",
                                  { staticClass: "has-vertical-middle" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "badge badge-sm" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$filters.formatCurrency(
                                                _vm.totalValue(assessment[0]),
                                                _vm.$userInfo.locale
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                staticClass: "has-vertical-middle",
                                class: _vm.hasTagValue(assessment[1])
                                  ? "has-text-centered"
                                  : "",
                                attrs: {
                                  colspan: _vm.hasTagValue(assessment[1])
                                    ? _vm.numValuesInColumn
                                    : 1,
                                },
                              },
                              [
                                assessment[1]
                                  ? _c("div", [
                                      assessment[1].isQuoteItemDeleted
                                        ? _c("div", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-sm tag is-danger",
                                              },
                                              [_vm._v(" Deleted ")]
                                            ),
                                          ])
                                        : assessment[1].reportOnly
                                        ? _c("div", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-sm tag is-info",
                                              },
                                              [_vm._v(" Report Only ")]
                                            ),
                                          ])
                                        : _c("div", [
                                            _c(
                                              "div",
                                              {
                                                class:
                                                  _vm.getTextColor(assessment),
                                              },
                                              [
                                                _vm.numValuesInColumn > 1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "badge badge-sm",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$filters.formatNumber(
                                                              assessment[1]
                                                                .hourValue
                                                            )
                                                          ) + "h "
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "badge badge-sm",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$filters.formatCurrency(
                                                                _vm.totalValue(
                                                                  assessment[1]
                                                                ),
                                                                _vm.$userInfo
                                                                  .locale
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            ),
                                          ]),
                                    ])
                                  : _c("div", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "badge badge-sm tag is-warning",
                                        },
                                        [_vm._v("Pending")]
                                      ),
                                    ]),
                              ]
                            ),
                            _vm.numValuesInColumn > 1 &&
                            !_vm.hasTagValue(assessment[1])
                              ? _c(
                                  "td",
                                  { class: _vm.getTextColor(assessment) },
                                  [
                                    assessment[1]
                                      ? _c(
                                          "span",
                                          { staticClass: "badge badge-sm" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$filters.formatCurrency(
                                                    _vm.totalValue(
                                                      assessment[1]
                                                    ),
                                                    _vm.$userInfo.locale
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _c("div", [
        _c("div", { staticClass: "supp-container" }, [
          _c(
            "span",
            {
              staticClass: "has-text-weight-semibold",
              class: `is-size-${_vm.iconSize} ${_vm.supplementaryIconColour}`,
            },
            [
              _vm._v(
                _vm._s(_vm.supplementaryNo > 0 ? _vm.supplementaryNo : "O")
              ),
            ]
          ),
          _vm.authorisedValueDiff > 0
            ? _c(
                "span",
                {
                  staticClass: "change-icon",
                  class: `is-size-${_vm.iconSize + 3}`,
                },
                [
                  _c("i", {
                    staticClass: "has-text-success mdi mdi-arrow-up-box",
                  }),
                ]
              )
            : _vm._e(),
          _vm.authorisedValueDiff < 0
            ? _c(
                "span",
                {
                  staticClass: "change-icon",
                  class: `is-size-${_vm.iconSize + 3}`,
                },
                [
                  _c("i", {
                    staticClass: "has-text-danger mdi mdi-arrow-down-box",
                  }),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }